export default __webpack_public_path__ + "static/media/actionNodeIcon.d92c12cd.svg";